"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { Tooltip } from "react-tooltip";
import { AuthContext } from "@/components/auth/Auth";
import { useWaveEligibility } from "@/contexts/wave/WaveEligibilityContext";
import { ChatRestriction } from "@/hooks/useDropPriviledges";
interface WaveDropActionsReplyProps {
  readonly drop: ApiDrop;
  readonly activePartIndex: number;
  readonly onReply: () => void;
}
const WaveDropActionsReply: React.FC<WaveDropActionsReplyProps> = t0 => {
  const $ = _c(28);
  const {
    onReply,
    drop
  } = t0;
  const {
    setToast
  } = useContext(AuthContext);
  const {
    getEligibility
  } = useWaveEligibility();
  let t1;
  if ($[0] !== drop.id) {
    t1 = drop.id.startsWith("temp-");
    $[0] = drop.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isTemporaryDrop = t1;
  let t2;
  if ($[2] !== drop.wave.id || $[3] !== getEligibility) {
    t2 = getEligibility(drop.wave.id);
    $[2] = drop.wave.id;
    $[3] = getEligibility;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const waveEligibility = t2;
  const isEligibleToChat = waveEligibility?.authenticated_user_eligible_to_chat ?? drop.wave.authenticated_user_eligible_to_chat;
  const isSlowModeOnlyBlock = isEligibleToChat === false && waveEligibility?.authenticated_user_chat_restriction === ChatRestriction.SLOW_MODE;
  const canReply = !isTemporaryDrop;
  let t3;
  if ($[5] !== isEligibleToChat || $[6] !== isSlowModeOnlyBlock || $[7] !== onReply || $[8] !== setToast) {
    t3 = () => {
      if (isEligibleToChat === false && !isSlowModeOnlyBlock) {
        setToast({
          message: "You are not eligible to chat in this wave",
          type: "error"
        });
        return;
      }
      onReply();
    };
    $[5] = isEligibleToChat;
    $[6] = isSlowModeOnlyBlock;
    $[7] = onReply;
    $[8] = setToast;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleReplyClick = t3;
  const t4 = `tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-iron-400 tw-transition-all tw-duration-200 tw-ease-out desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-200 ${!canReply ? "tw-cursor-default tw-opacity-50" : "tw-cursor-pointer"}`;
  const t5 = canReply ? handleReplyClick : undefined;
  const t6 = !canReply;
  let t7;
  if ($[10] !== drop.id || $[11] !== isTemporaryDrop) {
    t7 = !isTemporaryDrop ? {
      "data-tooltip-id": `reply-${drop.id}`
    } : {};
    $[10] = drop.id;
    $[11] = isTemporaryDrop;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = `tw-h-5 tw-w-5 tw-flex-shrink-0 tw-transition tw-duration-300 tw-ease-out ${canReply ? "" : "tw-opacity-50"}`;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <path strokeLinecap="round" strokeLinejoin="round" d="M7.49 12 3.74 8.248m0 0 3.75-3.75m-3.75 3.75h16.5V19.5" />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8) {
    t10 = <svg className={t8} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">{t9}</svg>;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t11 = <button className={t4} onClick={t5} disabled={t6} aria-label="Reply to drop" {...t7}>{t10}</button>;
    $[16] = t10;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== drop.id || $[23] !== isTemporaryDrop) {
    t12 = !isTemporaryDrop && <Tooltip id={`reply-${drop.id}`} place="top" offset={8} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    }}><span className="tw-text-xs">Reply</span></Tooltip>;
    $[22] = drop.id;
    $[23] = isTemporaryDrop;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};
export default WaveDropActionsReply;